"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function hiddenInput(context) {
  var css = context.css;
  var name = 'hidden-input';
  return css(name, {
    display: 'none'
  });
}

exports.hiddenInput = hiddenInput;